import { z } from 'zod';
/**
 * Clubrollen zoals Better Auth ze in `member.role` opslaat.
 * - member: trainer
 * - admin / owner: clubbeheerder (owner kan ook andere owners aanwijzen)
 */
export const clubRoleSchema = z.enum(['owner', 'admin', 'member']);
/** Rollen die een clubbeheerder kan uitnodigen; owner alleen via platform of rolwijziging. */
export const invitableRoleSchema = z.enum(['admin', 'member']);
export const platformRoleSchema = z.enum(['PLATFORM_ADMIN', 'PLATFORM_MODERATOR']);
export const isClubManager = (role) => role === 'owner' || role === 'admin';
const email = z
    .string()
    .trim()
    .toLowerCase()
    .pipe(z.email({ message: 'Vul een geldig e-mailadres in.' }));
// --- Organisaties en actieve club -------------------------------------------
export const organizationSummarySchema = z.object({
    id: z.string(),
    name: z.string(),
    slug: z.string(),
    role: clubRoleSchema,
});
export const organizationsResponseSchema = z.object({
    organizations: z.array(organizationSummarySchema),
    /** null = persoonlijke modus */
    activeOrganizationId: z.string().nullable(),
});
export const setActiveOrganizationRequestSchema = z.object({
    organizationId: z.string().min(1).nullable(),
});
export const organizationResponseSchema = z.object({ organization: organizationSummarySchema });
// --- Leden ------------------------------------------------------------------
export const memberSchema = z.object({
    id: z.string(),
    userId: z.string(),
    name: z.string(),
    /** Alleen zichtbaar voor clubbeheerders. */
    email: z.string().optional(),
    role: clubRoleSchema,
    joinedAt: z.string(),
});
export const membersResponseSchema = z.object({ members: z.array(memberSchema) });
export const updateMemberRequestSchema = z.object({ role: clubRoleSchema });
// --- Uitnodigingen -----------------------------------------------------------
export const invitationStatusSchema = z.enum(['pending', 'accepted', 'rejected', 'canceled']);
export const createInvitationRequestSchema = z.object({
    email,
    role: invitableRoleSchema.default('member'),
});
export const invitationSchema = z.object({
    id: z.string(),
    email: z.string(),
    role: clubRoleSchema,
    expiresAt: z.string(),
    /** Link voor de genodigde; tonen aan de beheerder zolang er geen SMTP is. */
    inviteUrl: z.string(),
});
export const invitationsResponseSchema = z.object({ invitations: z.array(invitationSchema) });
export const invitationResponseSchema = z.object({ invitation: invitationSchema });
/** Wat de genodigde zelf ziet op /uitnodiging/:id. */
export const invitationDetailsSchema = z.object({
    id: z.string(),
    organizationName: z.string(),
    role: clubRoleSchema,
    inviterName: z.string(),
    expiresAt: z.string(),
});
export const invitationDetailsResponseSchema = z.object({ invitation: invitationDetailsSchema });
// --- Platformbeheer ----------------------------------------------------------
export const slugSchema = z
    .string()
    .trim()
    .toLowerCase()
    .regex(/^[a-z0-9]+(-[a-z0-9]+)*$/, {
    message: 'Gebruik kleine letters, cijfers en streepjes, bijvoorbeeld vcv-veenendaal.',
})
    .min(3, { message: 'Gebruik minimaal 3 tekens.' })
    .max(48, { message: 'Gebruik maximaal 48 tekens.' });
export const createOrganizationRequestSchema = z.object({
    name: z
        .string()
        .trim()
        .min(2, { message: 'Vul de naam van de club in.' })
        .max(100, { message: 'Gebruik maximaal 100 tekens.' }),
    slug: slugSchema,
    adminEmail: email,
});
export const platformOrganizationSchema = z.object({
    id: z.string(),
    name: z.string(),
    slug: z.string(),
    memberCount: z.number().int(),
    createdAt: z.string(),
});
export const platformOrganizationsResponseSchema = z.object({
    organizations: z.array(platformOrganizationSchema),
});
export const createOrganizationResponseSchema = z.object({
    organization: platformOrganizationSchema,
    invitation: invitationSchema,
});
//# sourceMappingURL=organizations.js.map